export default "__VITE_ASSET__47a1ca04__"